export const SIGNUP_MSISDN_SUBMIT_START = 'SIGNUP_MSISDN_SUBMIT_START';
export const SIGNUP_MSISDN_SUBMIT_SUCCESS = 'SIGNUP_MSISDN_SUBMIT_SUCCESS';
export const SIGNUP_MSISDN_SUBMIT_FAIL = 'SIGNUP_MSISDN_SUBMIT_FAIL';
export const SIGNUP_MSISDN_SUBMIT_RESET = 'SIGNUP_MSISDN_SUBMIT_RESET';
